<div class="header">
    <label>Applied Changes</label>
    <a class="close-button" (click)="closeDialog()">×</a>
</div>
<hr>
<div class="scroll-table">
    <uses-changes-table [calibrationUsesLabels]="calibrationUsesLabels"></uses-changes-table>
    <overlay-typology-changes-table [overlayTypologyLabels]="overlayTypologyLabels"></overlay-typology-changes-table>
</div>
